export const USER_PROFILE_REQUESTED = 'security/USER_PROFILE_REQUESTED';
export const USER_PROFILE_REQUEST_SUCCEEDED = 'security/USER_PROFILE_REQUEST_SUCCEEDED';
